<template>
  <div class="vehicle-schedule-main" ref="vehicleScheduleMain" :draggable="false">
    <div class="vehicle-schedule-body" ref="vehicleScheduleBody" :style="{ 'user-select': (portBData['resize'] ? 'none' : '') }">
      <ContextMenu :left="contextLeft" :top="contextTop" :show="contextShow" :hasHeader="hasHeader"/>

      <gantt class="gantt" ref="myGantt" :tasks="myTasks" :showCheckBox="false" :showCategories="false" dateTitle="Show timeline from"
        :fromDate.sync="fromDate" :toDate.sync="toDate" @loaded="ganttLoaded" @refreshClicked="ganttRefresh" :ganttLegend="legends"
        :dataFromServer="dataFromServer"/>

      <EntryPopup class="portBPopup" ref="portBPopup" :show="portBShow" :title="portBTitle" :newStyle="true" :isComponent="true" :content.sync="portBContent"
          @saved="portBBtn('save')" @cancelClick="portBBtn('cancel')" 
          :disabledSave="portBData['portBLoadShow'] || (portBData['timeout'] <= 0) || (portBData['portBErrors']['length'] > 0)"
          :errorMessages="portBData['portBErrors']" :successMessages="portBData['portBSuccess']"/>
          
    </div>
    <div class="vehicle-schedule-resize" @mousedown="portBBtn('resize')" :draggable="false"></div>
    <div class="vehicle-schedule-portB" :draggable="false"
        :style="{ 'user-select': (pendingTripsData['resize'] ? 'none' : ''),
            'width': (pendingTripsData['portBSizeX']  + 'px'),
            'min-width': (pendingTripsData['portBSizeX']  + 'px'),
            'transition': (pendingTripsData['resize'] ? '' : '0.3s'), }">
        <div class="header" :style="{ 'background-color': (portBData['portBJobTypeShow'] ? '#42a81dff' : '') }">
          <div class="headerTripsSel" v-if="pendingTripsData['pTripsSel'] && !portBData['portBJobTypeShow']"> 
            <button class="headerBtn" @click="portBBtn('pendingtripback')"> ᐊ </button>
            <div class="headerTitle"> {{pendingTripsData['pTripsSel']['ConsignmentNo']}} </div>
          </div>

          <div class="headerTitle" v-if="!pendingTripsData['pTripsSel'] && !portBData['portBJobTypeShow']">
            {{pendingTripsData['pTripsHeader']}}
          </div>

          <div class="headerTripsSel" v-if="portBData['portBJobTypeShow']"> 
            <button class="headerBtn" @click="portBBtn('portBback')"> ᐊ </button>
            <div class="headerTitle">{{portBData['portBJobTypeTitle']}}</div>
          </div>
        </div>

        <div class="pendingTripsMain">
          <div class="pendingTripsList" v-if="(!pendingTripsData['pTripsSel'] && !portBData['portBJobTypeShow']) || (portBData['portBJobTypeShow'] && portBData['portBJobTypePage'] == 'selection')">
            <div class="pendingTrips" v-for="(t, i) in pendingTripsData['pTrips'].filter((p) => { return !p['selected']; })" :key="'pTrip' + i" @click="portBBtn('selection', t)"> 
              <div class="left">
                <div class="row"> <div class="left">{{t['ContainerNo'] ? t['ContainerNo'].trim() : ''}}</div> <div class="right">{{t['ContSize'] ? t['ContSize'].trim() : ''}}{{t['ContType'] ? t['ContType'].trim() : ''}}</div> </div>
                <div class="row"> <div class="left">{{t['B2BContainerNo'] ? t['B2BContainerNo'].trim() : ''}}</div> <div class="right">{{t['B2BContSize'] ? t['B2BContSize'].trim() : ''}}{{t['B2BContType'] ? t['B2BContType'].trim() : ''}}</div> </div>
                <div class="row"> <div class="left">{{t['ConsignmentNo'] ? t['ConsignmentNo'].trim() : ''}}</div> <div class="right">{{t['MovementType'] ? t['MovementType'].trim() : ''}}</div> </div>
                <div class="row" v-if="t['B2BConsignmentNo']"> <div class="left">{{t['B2BConsignmentNo'] ? t['B2BConsignmentNo'].trim() : ''}}</div> <div class="right">{{t['MovementType'] ? t['MovementType'].trim() : ''}}</div> </div>
                <div class="row"> <div class="left">{{t['BillToName'] ? t['BillToName'].trim() : ''}}</div> <div class="right">[{{t['FromArea'] ? t['FromArea'].trim() : ''}} - {{t['ToArea'] ? t['ToArea'].trim() : ''}}]</div> </div>
                <!-- <div class="row">{{t['selected']}}</div> -->
              </div>
              <div class="right" v-if="!portBData['portBJobTypeShow']">
                <Tooltip @click.native="portBBtn('pendingtrip', t)" :showIndicator="true" position="left" tooltipText="Consignment Details"></Tooltip>
              </div>
              
            </div>
          </div>

          <div class="pendingTripsSel" v-if="pendingTripsData['pTripsSel'] && !portBData['portBJobTypeShow']"> 
            <div class="row" v-for="(d, i) in pendingTripsData['pTripsDetails']" :key="'detail' + i">
              <div class="title">{{d['title']}}</div>
              <div class="value">
                <div class="left" v-html="d['value']"></div>
                <div class="right"></div>
              </div>
            </div>
          </div>

          <div class="pendingNoTrips" v-if="pendingTripsData['pTripsLoading']">{{pendingTripsData['pTripsLoading']}}</div>
          <div class="pendingNoTrips" v-else-if="(pendingTripsData['pTrips']['length'] <= 0 && !portBData['portBJobTypeShow']) || (pendingTripsData['pTrips']['length'] <= 0 && portBData['portBJobTypePage'] == 'selection')">No Pending Trips Found</div>
        
          <div class="portBJobType" v-if="portBData['portBJobTypeShow'] && portBData['portBJobTypePage'] == 'type'">
            <button class="portBJobTypeBtn" @click="portBBtn('type', 'export')" :disabled="pendingTripsData['pTrips']['length'] <= 0">Export</button>
            <button class="portBJobTypeBtn" @click="portBBtn('type', 'import')" :disabled="pendingTripsData['pTrips']['length'] <= 0">Import</button>
            <button class="portBJobTypeBtn" @click="portBBtn('type', 'exportimport')" :disabled="pendingTripsData['pTrips']['length'] <= 1">Export & Import</button>
          </div>

          <div class="portBJobBook" v-if="portBData['portBJobTypeShow'] && portBData['portBJobTypePage'] == 'book'">
            <div class="portBJobItem" v-for="(j, i) in portBData['portBSelections']" :key="'job' + i">
              <div class="details">{{j['ConsignmentNo']}} </div>
              <div class="type">{{((i == 0 && portBData['portBJobType'] != 'import') ? 'Export' : 'Import')}}</div>
            </div>
          </div>
        </div>

        <div class="footer">
          <div class="footerFunctions">
            <button @click="portBBtn('bookPort')" :disabled="pendingTripsData['pTrips']['length'] <= 0 || portBData['portBJobTypeShow']"> Port Booking </button>
            <button disabled> Dropoff In </button>
          </div>
          <button @click="portBBtn('hamburger')" disabled> ... </button>

          <div class="footerHamburger" v-if="pendingTripsData['hamburgerShow']">
            <button> Placeholder </button>
            <button> Placeholder </button>
            <button> Placeholder </button>
          </div>
        </div>
    </div>
    
    <Loader loadingText="Loading" :isVisible.sync="loading"/>
    <div class="timeoutDIV" ref="timeoutDIV" id="timeoutDIV" style="display: none;">Timeout: {{timeoutTime}}</div>
  </div>
</template>

<script>
/* eslint-disable */
import 'vue-cal/dist/vuecal.css';
import '@/css/all.scss';
import Gantt from '@/components/Gantt.vue';
import Loader from '@/components/Loader.vue';
import ContextMenu from '@/components/CustomContextMenu.vue';
import Dropdown from '@/components/Dropdown.vue';
import EntryPopup from '@/components/EntryPopup.vue';

export default {
  components: {
    Gantt, Loader, ContextMenu, Dropdown, EntryPopup
  },
  data() {
    return {
      portBShow: false,
      portBTitle: 'Port Booking',
      portBContent: { type: 'PortBooking', popupData: this.portBData },

      pendingTripsData: {
        'resize': false,

        'bodySizeX': 0,

        'portBSizeX': 0,

        'pointerX': 0,
        'pointerY': 0,

        'hamburgerShow': false,

        'pTrips': [],
        'pTripsSel': null,
        'pTripsDetails': [],
        'pTripsLoading': '',
        'pTripsHeader': 'Pending Trips',
      },
    }
  },
  props: {
    myTasks: { type: Object, default: { data: [], links: [] } },
    dataFromServer: { type: Object, default: function() { return null } },
    loading: { type: Boolean, default: false },
    contextLeft: { type: Number, default: 0 },
    contextTop: { type: Number, default: 0 },
    contextShow: { type: Boolean, default: false },
    hasHeader: { type: Boolean, default: false },
    statusCategories: { type: Array, default: [
      { item: 'abc1', status: 1 },
      { item: 'abc2', status: 2 },
      { item: 'abc3', status: 3 }
    ]},
    fromDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0) },
    toDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59) },
    legends: { type: Array, default: function() { return [] } },

    //---- Port Booking Props
    portBData: { type: Object, default: function() { return {
      'portBJobTypeShow': false,
      'portBJobType': '',
      'portBJobTypeTitle': 'Booking Type',
      'portBJobTypePage': 'type',
      'portBSelections': [],

      'portBLoadShow': false,
      'portBLoadText': 'Loading',
      'portBSuccess': [],
      'portBErrors': [],
      'slotError': '',
      
      'verificationList': [
        {
          'consignmentNo': 'Consignment No',
          'items': [
            { 'title': 'Driver Verified', 'status': '', 'data': ['', ''] },
            { 'title': 'Vehicle Head Verified', 'status':  '', 'data': ['', ''] },
            { 'title': 'Trailer Verified', 'status':  '', 'data': ['', ''] },
            { 'title': 'Container(s) Verified', 'status':  '', 'data': ['', ''] },
            { 'title': 'Port(s) DateTime', 'status':  '', 'data': ['', ''] },
          ],
        },
        // {
        //   'consignmentNo': 'Consignment No',
        //   'items': [
        //     { 'title': 'Driver', 'status': 'valid', 'data': ['Test', 'Test'] },
        //     { 'title': 'Vehicle Head', 'status':  'valid', 'data': ['Test', 'Test'] },
        //     { 'title': 'Trailer', 'status':  'valid', 'data': ['Test', 'Test'] },
        //     { 'title': 'Container(s)', 'status':  'valid', 'data': ['', ''] },
        //     { 'title': 'Port(s) DateTime', 'status':  'valid', 'data': ['Test', 'Test'] },
        //     { 'title': 'SOLAS', 'status':  'valid', 'data': ['Test', 'Test'] },
        //   ],
        // },
        // {
        //   'consignmentNo': 'Consignment No',
        //   'items': [
        //     { 'title': 'Driver', 'status': 'valid', 'data': ['Test', ''] },
        //     { 'title': 'Vehicle Head', 'status':  'valid', 'data': ['Test', 'Test'] },
        //     { 'title': 'Trailer', 'status':  '', 'data': ['Test', 'Test'] },
        //     { 'title': 'Container(s)', 'status':  '', 'data': ['', ''] },
        //     { 'title': 'Discharge', 'status':  '', 'data': ['Time', ''] },
        //     { 'title': 'SOLAS', 'status':  'valid', 'data': ['Test', 'Test'] },
        //   ],
        // },
      ],
      'verificationData': {},
      'verificationReturn': {
        'terminal': '',
        'remarks': '',
        'slot': null,
      },

      'timeoutInterval': null,
      'timeout': 300,

    }; }},
  },
  methods: {
    tooltipClick: async function(btn) {
      switch(btn) {
        case '':
          break;
      }
    },
    getUserID: function() {
      return this.$cookies.get('user')
    },
    taskDoubleClick: function(id, e) {

      var selectedTask = this.myTasks.data.filter(function(item) {
        return item.id == id;
      });
      var task = selectedTask[0];

      var selectedParent = this.myTasks.data.filter(function(item) {
        return item.id == task.parent;
      });
      var parent = selectedParent[0];

      // alert(JSON.stringify(task));
      var result = '';
      var duration = this.$dateTime.getDateTimeDifference(task.end_date, task.start_date);

      result += `Start: ${this.$dateTime.getDateTime(task.start_date, 'dd/MM/yyyy HH:mm')}\n`;
      result += `End: ${this.$dateTime.getDateTime(task.end_date, 'dd/MM/yyyy HH:mm')}\n`;
      result += `Duration: ${duration.hour} Hours ${duration.min} Minutes\n`;
      result += `Progress: ${Math.round(task.progress * 100)}%`;

      // alert(result);
      // swal.fire(
      //   `${task.text} of ${parent.text}`,
      //   result,
      //   'info'
      // );
      
      //---- Get id of row clicked
      this.portBBtn('ganttrowclick', task)
    },
    contextMenu: function(e) {
      e.preventDefault();

      if (e.target.id == 'first') {
        this.hasHeader = false;
      } else {
        this.hasHeader = true;
      }

      this.contextShow = true;
      this.contextLeft = e.clientX;
      this.contextTop = e.clientY - 80;
    },
    categorySelected: function(item) {
      var selectedCategory = this.statusCategories.filter((s) => {
        return s.Description == item;
      });

      console.log(selectedCategory[0].StatusListCategory);
    },
    ganttLoaded: async function() {
      
    },
    ganttRefresh: async function() {
      this.loading = true;
      var newData = await this.$apiCallV2(`/VehicleSchedule/GanttViewTAS?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm')}&viewType=TEAM_PM`);
      this.loading = false;
      // console.log(newData);

      if (newData.data.data.length == 0) {
        this.dataFromServer = null;
        return;
      }

      this.setStartEndDate(newData.data);
    },
    setStartEndDate: function(oriData) {
      // Set inital end date
      var allItems = oriData.data;
      allItems.forEach((i) => {
        var date = new Date(i.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        if (date != 'Invalid Date' && i.duration) {
          i.myEndDate = date.setMinutes(date.getMinutes() + (i.duration * 30));
        }
      });
      // Set inital end date

      // Sort, get the minimum date and convert the value to a date obj
      allItems.sort((a, b) => {
        var dateA = new Date(a.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        var dateB = new Date(b.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));

        return dateA < dateB ? -1 : 1;
      });

      var minDate;
      for (var i = 0; i < allItems.length; i++) {
        var testDate = new Date(allItems[i].start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        if (testDate != 'Invalid Date') {
          minDate = allItems[i].start_date;
          break;
        }
      }

      var minDateObj = new Date(minDate.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
      // Sort, get the minimum date and convert the value to a date obj

      // Sort and get the maximum date which is the end date
      allItems.sort((a, b) => {
        if (!a.myEndDate) {
          a.myEndDate = 0;
        }
        if (!b.myEndDate) {
          b.myEndDate = 0;
        }

        return a.myEndDate < b.myEndDate ? 1 : -1;
      });
      // Sort and get the maximum date which is the end date

      oriData.ganttStart = minDateObj;
      oriData.ganttEnd = new Date(allItems[0].myEndDate);

      this.dataFromServer = oriData;
    },
    portBBtn: async function(btn, cmd) {
      //---- Set variables
      var bodyDOM = this.$refs['vehicleScheduleMain'];

      switch(btn) {
        case 'resize':
          this.$set(this.pendingTripsData, 'bodySizeX', bodyDOM.getBoundingClientRect()['width']);
          this.$set(this.pendingTripsData, 'resize', true);
          break;
        case 'hamburger':
          this.$set(this.pendingTripsData, 'hamburgerShow', !this.pendingTripsData['hamburgerShow']);
          break;
        case 'pendingtrip':
          this.$set(this.pendingTripsData, 'pTripsSel', JSON.parse(JSON.stringify(cmd)));
          // console.log(this.portBData['pTripsSel']);
          console.log(this.pendingTripsData['pTripsSel']['JourneyGUID']);

          this.$set(this.pendingTripsData, 'pTripsDetails', []);
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Trip #', 'value': this.pendingTripsData['pTripsSel']['Operator'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Cust', 'value': this.pendingTripsData['pTripsSel']['BillToName'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Cont #', 'value': this.pendingTripsData['pTripsSel']['ContainerNo'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'B2B', 'value': this.pendingTripsData['pTripsSel']['B2BContainerNo'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'B2B CN', 'value': this.pendingTripsData['pTripsSel']['B2BConsignmentNo'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Bkg Ref', 'value': this.pendingTripsData['pTripsSel']['B2BBookingRefNo'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'From', 'value': this.pendingTripsData['pTripsSel']['FromArea'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Tel No1', 'value': this.pendingTripsData['pTripsSel']['ToTelNo1'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Tel No2', 'value': this.pendingTripsData['pTripsSel']['ToTelNo2'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Address', 'value': this.pendingTripsData['pTripsSel']['FromAddress'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'To', 'value': this.pendingTripsData['pTripsSel']['ToArea'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Address', 'value': this.pendingTripsData['pTripsSel']['ToAddress'] });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'B2B To', 'value': '' });
          this.pendingTripsData['pTripsDetails'].push({ 'title': 'Operator', 'value': this.pendingTripsData['pTripsSel']['Operator'] });
          break;
        case 'pendingtripback':
          this.$set(this.pendingTripsData, 'pTripsSel', null);
          break;
        case 'portBback':
          this.$set(this.portBData, 'portBJobTypeShow', false);
          this.$set(this.portBData, 'portBJobType', '');
          this.$set(this.portBData, 'portBJobTypeTitle', 'Booking Type');
          this.$set(this.portBData, 'portBJobTypePage', 'type');
          this.$set(this.portBData, 'portBSelections', []);

          this.pendingTripsData['pTrips'].forEach((t) => { delete t['selected']; });
          break;
        case 'ganttrowclick':

          //---- Get Pending Trips Data
          var match = [];
          var pattern = /\[([^}]*)\]/g;
          var id = '';
          while (match = pattern.exec(cmd['col2Text'])) { id = match[0].replace(/\[|\]/g, ''); }
          
          if (!id.trim()) { 
            //---- Close Pending Trips
            this.$set(this.pendingTripsData, 'portBSizeX', 0);

            //---- Reset Pending Trips
            this.$set(this.pendingTripsData, 'pTrips', []);
            this.$set(this.pendingTripsData, 'pTripsLoading', '');
          } else {
            //---- Open Pending Trips
            this.$set(this.pendingTripsData, 'portBSizeX', 350);

            //---- Reset Pending Trips Selected
            this.$set(this.pendingTripsData, 'pTripsSel', null);

            //---- Reset Port Booking Selection
            this.$set(this.portBData, 'portBJobTypeShow', false);
            this.$set(this.portBData, 'portBJobType', '');
            this.$set(this.portBData, 'portBJobTypeTitle', 'Booking Type');
            this.$set(this.portBData, 'portBJobTypePage', 'type');
            this.$set(this.portBData, 'portBSelections', []);

            //---- Format Header
            this.$set(this.pendingTripsData, 'pTripsHeader', cmd['col1Text'].split('\-')[0] + ' (' + cmd['col1Text'].split('\-')[1] + ') - ' + cmd['col2Text'].replace(/\[|\]/g, ''));

            //---- Get Pending Trips
            this.$set(this.pendingTripsData, 'pTrips', []);
            this.$set(this.pendingTripsData, 'pTripsLoading', 'Loading Trips');
            var request = await this.$apiCallV2('/VehicleSchedule/GetHMSTripsByDriver?driver=' + id);
            if (Array.isArray(request['data'])) {
              // if (request['data']['length'] > 0) { this.$set(this.portBData, 'pTrips', request['data']); }
              this.$set(this.pendingTripsData, 'pTrips', request['data']);
              console.log(request['data']);
            } else { console.log(request['data']); }

            this.$set(this.pendingTripsData, 'pTripsLoading', '');
          }
          break;
        case 'bookPort':
          this.$set(this.portBData, 'portBJobTypeShow', true);
          break;
        case 'save':
          this.$set(this.portBData, 'portBSuccess', []);
          this.$set(this.portBData, 'portBErrors', []);

          //---- Check for Required Data
          this.$set(this.portBData, 'slotError', '');

          this.$nextTick(async () => {
            this.$set(this.portBData, 'slotError', this.portBData['verificationReturn']['slot'] ? '' : 'Time slot is required');

            if (!this.portBData['slotError']) {
              // console.log(this.portBData['portBSelections']);
              var s = this.portBData['portBSelections'];
              var dataToPost = {
                'server': 'production',
                
                'journeyguid': s[0]['JourneyGUID'] ? s[0]['JourneyGUID'].trim() : '',
                'addjourneyguid': (this.portBData['portBJobType'] == 'exportimport') ? ((s['length'] > 1) ? (s[1]['JourneyGUID'] ? s[1]['JourneyGUID'].trim() : '') : '') : '',
                // 'bookingtype': ((i == 0 && this.portBData['portBJobType'] != 'import') ? 'export' : 'import'),
                'bookingtype': this.portBData['portBJobType'],
                'action': 'N',
                'terminal': this.portBData['verificationReturn']['terminal'] ? this.portBData['verificationReturn']['terminal'].trim() : '',
                'timeslot': this.portBData['verificationReturn']['slot']['start'],
                'notes': this.portBData['verificationReturn']['remarks'] ? this.portBData['verificationReturn']['remarks'].trim() : '',
              }
              console.log(dataToPost);

              var request = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPost);
              console.log(request);
              
              if (Array.isArray(request['data'])) {
                if (request['data'][0]['Results'] <= 0) {
                  console.log('%cPortB Success', 'color: green;', request['data']);
                  
                  this.portBData['portBSuccess'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + request['data'][0]['ErrMsg']['message']);
                } else { 
                  console.log('%cPortB Error', 'color: red;', request['data'][0]['ErrMsg']);

                  this.portBData['portBErrors'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + request['data'][0]['ErrMsg']);
                }

              } else if (typeof request['data'] == 'object') {
                console.log('%cPortB Success', 'color: green;', request['data']);
              } else {
                console.log('%cPortB Error', 'color: red;', request['data']);

                this.portBData['portBErrors'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + request['data']);
              }


            } else {
              this.portBData['portBErrors'].push('Please ensure required fields are not empty');
            }
          });
          break;
        case 'cancel':
          this.portBTitle = 'Port Booking';
          this.portBShow = false;
          
          //---- Reset Port Booking Screen
          this.$set(this.portBData, 'verificationList', [
            {
              'consignmentNo': 'Consignment No',
              'items': [
                { 'title': 'Driver Verified', 'status': '', 'data': ['', ''] },
                { 'title': 'Vehicle Head Verified', 'status':  '', 'data': ['', ''] },
                { 'title': 'Trailer Verified', 'status':  '', 'data': ['', ''] },
                { 'title': 'Container(s) Verified', 'status':  '', 'data': ['', ''] },
                { 'title': 'Port(s) DateTime', 'status':  '', 'data': ['', ''] },
              ],
            }
          ]);
          this.$set(this.portBData['verificationReturn'], 'slot', null);
          this.$set(this.portBData['verificationReturn'], 'terminal', '');
          this.$set(this.portBData['verificationReturn'], 'remarks', '');
          this.$set(this.portBData, 'verificationData', null);
          this.$set(this.portBData, 'portBSuccess', []);
          this.$set(this.portBData, 'portBErrors', []);
          this.$set(this.portBData, 'slotError', '');

          //---- Reset Pending Trips Page
          this.portBBtn('portBback');

          //---- Cancel Interval
          clearInterval(this.portBData['timeoutInterval']);
          this.$set(this.portBData, 'timeoutInterval', null);
          this.$set(this.portBData, 'timeout', 300);
          break;
        case 'type':
          this.$set(this.pendingTripsData, 'pTripsSel', null);

          //---- Set Job Type and Show selection
          // console.log(cmd);
          this.$set(this.portBData, 'portBJobType', cmd);
          this.$set(this.portBData, 'portBJobTypePage', 'selection');

          //---- Set Title
          var titletype = '';
          switch(this.portBData['portBJobType']) {
            case 'export':
              titletype = 'Export';
              break;
            case 'import':
              titletype = 'Import';
              break;
            case 'exportimport':
              titletype = 'Export';
              break;
          }
          this.$set(this.portBData, 'portBJobTypeTitle', 'Select an ' + titletype);
          // console.log(titletype);
          break;
        case 'selection':
          if (this.portBData['portBJobTypeShow']) {
            // this.$set(this.portBData, 'portBJobTypePage', 'book');

            //---- Format Pending Trip with extra data
            this.$set(cmd, 'selected', true);
            this.portBData['portBSelections'].push(cmd);

            switch(this.portBData['portBJobType']) {
              case 'export':
                if (this.portBData['portBSelections']['length'] >= 1) {
                  this.$set(this.portBData, 'portBJobTypeTitle', 'Export');
                  this.$set(this.portBData, 'portBJobTypePage', 'book');
                  this.portBBtn('booking');
                }
                break;
              case 'import':
                if (this.portBData['portBSelections']['length'] >= 1) {
                  this.$set(this.portBData, 'portBJobTypeTitle', 'Import');
                  this.$set(this.portBData, 'portBJobTypePage', 'book');
                  this.portBBtn('booking');
                }
                break;
              case 'exportimport':
                if (this.portBData['portBSelections']['length'] >= 2) {
                  this.$set(this.portBData, 'portBJobTypeTitle', 'Export & Import');
                  this.$set(this.portBData, 'portBJobTypePage', 'book');
                  this.portBBtn('booking');
                } else if (this.portBData['portBSelections']['length'] >= 1) {
                  this.$set(this.portBData, 'portBJobTypeTitle', 'Select an Import');
                }
                break;
            }

          }
          break;
        case 'booking':
            this.portBTitle = 'Port Booking - ';
            this.portBData['portBSelections'].forEach((s, i) => {
              var impExp = ((i == 0 && this.portBData['portBJobType'] != 'import') ? 'EXP' : 'IMP');
              var consignmentNo = s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : 'Consignment #';
              var containerNo = s['ContainerNo'] ? s['ContainerNo'].trim() : 'Container #';

              this.portBTitle += '[' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';
            });
            this.portBShow = true;
              
            //---- Reset Port Booking Screen
            this.$set(this.portBData, 'verificationList', [
              {
                'consignmentNo': 'Consignment No',
                'items': [
                  { 'title': 'Driver Verified', 'status': '', 'data': ['', ''] },
                  { 'title': 'Vehicle Head Verified', 'status':  '', 'data': ['', ''] },
                  { 'title': 'Trailer Verified', 'status':  '', 'data': ['', ''] },
                  { 'title': 'Container(s) Verified', 'status':  '', 'data': ['', ''] },
                  { 'title': 'Port(s) DateTime', 'status':  '', 'data': ['', ''] },
                ],
              }
            ]);
            this.$set(this.portBData['verificationReturn'], 'slot', null);
            this.$set(this.portBData['verificationReturn'], 'terminal', '');
            this.$set(this.portBData['verificationReturn'], 'remarks', '');
            this.$set(this.portBData, 'verificationData', null);
            this.$set(this.portBData, 'portBSuccess', []);
            this.$set(this.portBData, 'portBErrors', []);

            clearInterval(this.portBData['timeoutInterval']);
            this.$set(this.portBData, 'timeout', 300);

            //---- Port Booking first API call
            this.$set(this.portBData, 'portBLoadShow', true);
            this.$set(this.portBData, 'portBLoadText', 'Verifying Trip');

            //---- Variables to check if number of request is okay
            var reqNum = 0;

            //---- Get Popup DOM
            try {
              var popupDOM = this.$refs['portBPopup']['$el'];
              var popupHeaderDOM = Array.from(popupDOM['childNodes'][0]['childNodes']).filter((c, i) => { return c['className'] == 'header'; })[0];

              var timeoutDOMCheck = Array.from(popupHeaderDOM['childNodes']).filter((c, i) => { return c['id'] == 'timeoutDIV'; });
              if (timeoutDOMCheck['length'] <= 0) {
                var timeoutDOM = this.$refs['timeoutDIV'];
                timeoutDOM['style'] = '';

                popupHeaderDOM.appendChild(timeoutDOM);
              }
            } catch(e) {  }


            await this.portBData['portBSelections'].forEach(async (s, i) => {
              console.log(s['JourneyGUID']);
            
              //---- Verify Data
              var dataToPost = {
                'server': 'production',

                'journeyguid': s['JourneyGUID'] ? s['JourneyGUID'].trim() : '',
                'addjourneyguid': '',
                'bookingtype': ((i == 0 && this.portBData['portBJobType'] != 'import') ? 'export' : 'import'),
                'action': '',
                'terminal': '',
                'timeslot': '',
                'notes': ''
              }
              
              console.log('%cPost Data', 'color: hotpink', dataToPost);
            
              var request = await this.$apiCallV2('/VehicleSchedule/PortBooking', dataToPost);
              console.log(request);
              reqNum += 1;
              if (Array.isArray(request['data'])) {
                if (request['data'][0]['Results'] <= 0) {
                  console.log('%cPortB Success', 'color: green;', request['data']);
                  
                  this.portBData['portBSuccess'].push(request['data'][0]['ErrMsg']['message']);
                } else { 
                  console.log('%cPortB Error', 'color: red;', request['data'][0]['ErrMsg']);

                  this.portBData['portBErrors'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + request['data'][0]['ErrMsg']);
                }

              } else if (typeof request['data'] == 'object') {
                console.log('%cPortB Success', 'color: green;', request['data']);

                this.$set(this.portBData, 'verificationData', request['data']);

                //---- Return Success Message
                this.portBData['portBSuccess'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + 'Verification successful. Please proceed to click SAVE to Book a timeslot.');

                //---- Success 1st API
                this.$set(this.portBData['verificationReturn'], 'terminal', this.portBData['verificationData']['usecontterminal']);

                //---- Set List of Verified Items
                var steps = this.portBData['verificationData']['steps'];
                var veriTtems = [
                  { 'title': 'Driver', 'status': (steps ? (steps.search('1') >= 0 ? 'valid' : 'invalid') : ''), 'data': [
                      (this.portBData['verificationData']['drivernric'] ? this.portBData['verificationData']['drivernric'].trim() : ''), 
                      (s['DriverName'] ? s['DriverName'].trim() : '')
                    ]},
                  { 'title': 'Vehicle Head', 'status': (steps ? (steps.search('2') >= 0 ? 'valid' : 'invalid') : ''), 'data': [
                      (s['PMCode'] ? s['PMCode'].trim() : ''), 
                      (s['PMNo'] ? s['PMNo'].trim() : '')
                    ]},
                  { 'title': 'Trailer', 'status':  (steps ? (steps.search('3') >= 0 ? 'valid' : 'invalid') : ''), 'data': [
                      (s['TRCode'] ? s['TRCode'].trim() : ''), 
                      (s['TRNo'] ? s['TRNo'].trim() : '')
                    ]},
                  { 'title': 'Container(s)', 'status':  (steps ? (steps.search('4') >= 0 ? 'valid' : 'invalid') : ''), 'data': [
                      (s['ContainerNo'] ? s['ContainerNo'].trim() : ''), 
                      (s['B2BContainerNo'] ? s['B2BContainerNo'].trim() : '')
                    ]},
                  { 'title': 'Port(s) DateTime', 'status':  'valid', 'data': [
                      (s['ContainerNo'] ? (this.portBData['verificationData']['port_opening'] ? ('Open : ' + this.portBData['verificationData']['port_opening'].trim()) : '') : ''), 
                      (s['ContainerNo'] ? (this.portBData['verificationData']['port_closing'] ? ('Close: ' + this.portBData['verificationData']['port_closing'].trim()) : '') : '')
                    ]},
                ]

                //-- Item to hide if does not exist
                if (s['B2BContainerNo']) {
                  veriTtems.push(
                    { 'title': 'Port(s) DateTime (B2B)', 'status':  'valid', 'data': [
                        (s['B2BContainerNo'] ? (this.portBData['verificationData']['b2bport_opening'] ? ('Open : ' + this.portBData['verificationData']['b2bport_opening'].trim()) : '') : ''), 
                        (s['B2BContainerNo'] ? (this.portBData['verificationData']['b2bport_closing'] ? ('Close: ' + this.portBData['verificationData']['b2bport_closing'].trim()) : '') : '')
                      ]},
                  );
                }

                //-- Empty and submit items to preview
                this.$set(this.portBData, 'verificationList', []);
                this.portBData['verificationList'].push({
                  'consignmentNo': (s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : ''),
                  'items': veriTtems,
                });
                
              } else { 
                console.log('%cPortB Error', 'color: red;', request['data']);

                this.portBData['portBErrors'].push((s['ConsignmentNo'] ? s['ConsignmentNo'].trim() : '') + ' > ' + request['data']);
              }

              if (reqNum >= 2 && this.portBData['portBJobType'] != 'import' && this.portBData['portBJobType'] != 'export') {
                this.$set(this.portBData, 'portBLoadShow', false);
                this.$set(this.portBData, 'portBLoadText', 'Loading');

                clearInterval(this.portBData['timeoutInterval']);
                this.$set(this.portBData, 'timeoutInterval', setInterval(() => { 
                  this.$set(this.portBData, 'timeout', this.portBData['timeout'] - 1);
                  if (this.portBData['timeout'] <= 0) {
                    clearInterval(this.portBData['timeoutInterval']);
                    this.$set(this.portBData, 'timeoutInterval', null);
                  }
                }, 1000));
              } else if (reqNum >= 1 && this.portBData['portBJobType'] != 'exportimport') {
                this.$set(this.portBData, 'portBLoadShow', false);
                this.$set(this.portBData, 'portBLoadText', 'Loading');

                clearInterval(this.portBData['timeoutInterval']);
                this.$set(this.portBData, 'timeoutInterval', setInterval(() => { 
                  this.$set(this.portBData, 'timeout', this.portBData['timeout'] - 1);
                  if (this.portBData['timeout'] <= 0) {
                    clearInterval(this.portBData['timeoutInterval']);
                    this.$set(this.portBData, 'timeoutInterval', null);
                  }
                }, 1000));
              }
            });

            console.log(this.portBData['verificationList']);
          break;
      }
    },
    portBResizeMove: async function(event) {
      if (this.pendingTripsData['resize']) {
        this.$set(this.pendingTripsData, 'pointerX', event['clientX']);
        this.$set(this.pendingTripsData, 'pointerY', event['clientY']);
        this.$set(this.pendingTripsData, 'portBSizeX', ((this.pendingTripsData['bodySizeX'] - this.pendingTripsData['pointerX'] - 14) < 0 ? 0 : 
            ((this.pendingTripsData['bodySizeX'] - this.pendingTripsData['pointerX'] - 14) > 350) ? 350 : (this.pendingTripsData['bodySizeX'] - this.pendingTripsData['pointerX'] - 14)));
      }
    },
    portBResizeReset: async function(event) {
      this.$set(this.pendingTripsData, 'resize', false);
    },
  },
  computed: {
    timeoutTime() {
      return Math.floor(this.portBData['timeout'] / 60) + ':'+ (Math.floor(this.portBData['timeout'] % 60) < 10 ? '0' : '') + Math.floor(this.portBData['timeout'] % 60);
    },
  },  
  async mounted() {
    //---- Detect mouseUp
    window.addEventListener('mousemove', (e) => { this.portBResizeMove(e); });
    window.addEventListener('mouseup', (e) => { this.portBResizeReset(e); });
    window.addEventListener('mouseleave', (e) => { this.portBResizeReset(e); });

    //---- Others
    if (localStorage.getItem('ganttRefresh') == '0') {
      localStorage.setItem('ganttRefresh', '1');
      window.location.reload();
      this.loading = true;
      return;
    }

    gantt.attachEvent('onTaskClick', this.taskDoubleClick);

    this.loading = true;
    var newData = await this.$apiCallV2(`/VehicleSchedule/GanttViewTAS?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm')}&viewType=TEAM_PM`);
    this.loading = false;

    // console.log(newData.data);
    // if (Array.isArray(newData['data']['data'])) {
    //   newData.data['data'].forEach((d) => {
    //     this.$set(d, 'start_date', '14-07-2021 00:00');
    //   });
    // }

    this.setStartEndDate(newData.data);

    var getLegends = await this.$apiCallV2('/VehicleSchedule/GetLegends?viewType=TEAM_PM');
    getLegends.data.forEach((l) => {
      this.legends.push({ name: l.ColorDesc, color: l.ColorHexa });
    });
  }
};
</script>

<style lang="scss" scoped>
.vehicle-schedule-main {
  width: 100%;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > .vehicle-schedule-body {
    width: auto;
    height: 100%;
    padding: 5px;
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    overflow-x: scroll;

    > .portBPopup {
      width: auto;
      height: auto;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
  }
}

.timeoutDIV {
    width: auto;
    height: 100%;
    padding: 0 4px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
}

.vehicle-schedule-resize {
  width: auto;
  height: 100%;
  min-width: 10px;
  margin: 0 2px;
  background-color: lightgray;
  border: solid 1px lightgray;
  cursor: e-resize;
}

.vehicle-schedule-portB {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #eeef;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;

  > .header {
    width: 100%;
    height: 32px;
    padding: 0 5px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #f24a01;
    border-radius: 5px 5px 0 0;
    box-shadow: 0 0 4px #0008;
    user-select: none;
    z-index: 10;

    > .headerTripsSel {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      > .headerBtn {
        width: 30px; 
        height: 100%;
        margin: 0 5px 0 0;
        position: absolute;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: bold;
        color: #ffff;
        background-color: #0000;
      }

      > .headerBtn:hover {
        background-color: #0000;
      }

      > .headerBtn:focus {
        background-color: #0000;
        box-shadow: none;
        outline: none;
      }
    }
  }
  
  .headerTitle {
    width: auto;
    height: 100%;
    flex: 1;
    font-size: 14px;
    font-weight: bold;
    color: #ffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .footer {
    width: 100%;
    height: 38px;
    padding: 0 2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 0 4px #0008;
    z-index: 10;

    > .footerFunctions {
      width: auto;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;

      > button {
        margin: 0 2px;
      }
    }

    > .footerHamburger {
      width: 200px;
      height: auto;
      padding: 4px 4px 0 4px;
      position: absolute;
      bottom: 38px;
      right: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      background-color: #ffff;
      border-radius: 3px 0 0 0;
      box-shadow: 0 0 4px #0008;

      > button {
        width: 100%;
        margin: 0 0 4px 0;
      }
    }

    > button {
      margin: 0 2px;
    }
  }
}

.pendingTripsMain {
  width: 100%;
  height: auto;
  padding: 4px 4px 0 4px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #eaeaea;
  overflow-y: scroll;
}

.pendingTripsList {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.pendingTrips {
  width: 100%;
  padding: 2px 0;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffff;
  border: solid 1px #000f;
  cursor: pointer;

  > .left {
    width: auto;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    user-select: none;

    > .row {
      width: 100%;
      height: auto;
      padding: 0 4px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      overflow: visible;

      > .left {
        width: auto;
        height: 100%;
        margin: 0 4px 0 0;
        flex: 1;
        font-weight: bold;
        text-align: left;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        white-space: pre-wrap;
      }

      > .right {
        width: auto;
        height: 100%;
        max-width: 100px;
        text-align: right;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        white-space: pre-wrap;
      }
    }
  }

  > .right {
    width: auto;
    height: 100%;
    padding: 0 2px 0 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
  }

}

.pendingTrips:hover {
  background-color: #ffdab0;
  transition: 0.1s;
}

.pendingTripsSel {
  width: 100%;
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > .row {
    width: 100%;
    height: auto;
    font-size: 12px;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .title {
      width: 22%;
      height: 100%;
      margin: 0 5px 0 0;
      font-weight: bold;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }

    > .value {
      width: auto;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      > .left {
        width: auto;
        height: 100%;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        white-space: pre-wrap;
      }

      > .right {
        width: auto;
        height: 100%;
      }
    }   
  }
}

.portBJobType {
  width: 100%;
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > .portBJobTypeBtn {
    width: 100%;
    margin: 0 0 4px 0;
  }
}

.portBJobBook {
  width: 100%;
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > .portBJobItem {
    width: 100%;
    height: auto;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .details {
      width: auto;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    > .type {
      width: auto;
      height: 100%;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

.pendingNoTrips {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.myh4 {
  // background-color: red;
  width: 100%;
  text-align: center;
}

.calendar {
  width: 100%;
}

.gantt {
  width: auto;
  height: 100%;
  flex: 1;
}
</style>